// extracted by mini-css-extract-plugin
export var isPrintedCell = "_ym-1";
export var printerIcon = "_ym-0";